import type {SupportedFragments} from '@wix/document-services-types'
// eslint-disable-next-line import/no-unresolved
import appStateConfig from '@wix/dm-fragment-configs/configs/appStateConfig.json'

const extensionsList: string[] = [
    'branches',
    'schema',
    'componentDefinition',
    'logger',
    'environment',
    'hooks',
    'pageResourceLoader',
    'fragmentResourceLoader',
    'relationships',
    'dataAccess',
    'dataModel',
    'snapshots',
    'documentServicesModel',
    'data',
    'rendererModel',
    'structure',
    'menu',
    'page',
    'multilingual',
    'platform',
    'tpa',
    'saveState',
    'distributor',
    'mobile',
    'validationWhitelist',
    'dataFixerVersioning',
    'validations',
    'variants',
    'variables',
    'cssStyle',
    'slots',
    'componentsMetadata',
    'connections',
    'controllers',
    'routers',
    'platformAppReflow',
    'style',
    'theme',
    'deprecation',
    'components',
    'gridLayout',
    'defaultDefinitions',
    'internalRef',
    'refOverrides',
    'appController',
    'mobilePresets',
    'wixCode',
    'wixCodeFileSystem',
    'nicknames',
    'mobileConversion',
    'effects',
    'importExport',
    'features',
    'actionsAndBehaviors',
    'structureMetaData',
    'remoteStructureMetaData',
    'blocks',
    'atomicScopes',
    'siteStructure',
    'mobileHints',
    'serializedStructure',
    'appsInstallState',
    'platformSharedState',
    'mobileAlgo',
    'arrangement',
    'publishPipeline',
    'serviceTopology',
    'builderComponents',
    'builderStyle',
    'innerElements',
    'debug',
    'nicknameContext',
    'componentCode',
    'fixers',
    'fragments',
    'layout',
    'observables',
    'schemaResourceLoader',
    'accessibility'
]

const supportedFragments: SupportedFragments = {
    FragmentIndex: {
        loadOnInit: true
    },
    AppState: Object.assign(appStateConfig.defaultConfigurations, {
        loadOnInit: true
    })
}

export default {
    extensionsList,
    experimentalConfigOptions: {
        dm_fragments: {
            configOptions: {
                supportedFragments
            }
        }
    }
}
